export const FAQUrl =
  'https://abtasty.zendesk.com/hc/en-us/articles/360018899099-Troubleshooting-QA-Assistant-doesn-t-load-on-my-website';
